import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services'
import {
  UserInfo,
  AuthenticatePayload,
  SaveBulkEntryPayload,
  File,
  UploadFileResponse
} from './types'
import { RootState } from '../store'
import apiEndpoints from '../../const/apiEndpoints'
import { getSubjects } from '../learn/actions'
import {
  updatePassword,
  updateSelectedBatch,
  updateSelectedCourse,
  updateUserName
} from './actions'
import { ROLE } from '../../helpers/determineMenu'
import { DATE_FORMAT_YYYYMMDD } from '../../const/dateFormat'
import format from 'date-fns/format'
// import history from '../../const/history'
// import ROUTES from '../../const/routes'

export const handleAuthenticate = createAsyncThunk(
  'user/authenticate',
  async (
    payload: AuthenticatePayload,
    { getState, dispatch }
  ): Promise<UserInfo> => {
    const {
      user: { userName, password }

    } = getState() as RootState
    console.log(userName);

    const data = {
      userName: userName,
      password: password,
      loginDevice: payload.loginDevice
    }

    const response = await api.post(apiEndpoints.auth, data)
    const userInfo = response.data.data
    sessionStorage.setItem('edu-token', userInfo?.token)
    if (userInfo && userInfo.role === ROLE.STUDENT) {
      // const isResetPasswordRequired =
      //   userInfo.passwordUpdated === 'false' ? true : false
      // userInfo.isResetPasswordRequired = isResetPasswordRequired

      // if (isResetPasswordRequired) {
      //  history.push(ROUTES.RESET_PASSWORD, { isResetPasswordRequired })
      //  } else {
      const batchList = userInfo?.userDetail?.batchList
      if (batchList && batchList?.length) {
        dispatch(updateSelectedBatch(batchList[0]?.id))
        dispatch(updateSelectedCourse(batchList[0]?.courseId))

        const courseId =
          batchList[0]?.additionalCourseId || batchList[0]?.courseId
        await dispatch(
          getSubjects({
            courseId: courseId,
            batchId: batchList[0]?.id
          })
        )
      }
      // }
    }
    return userInfo
  }
)

export const handleLogout = createAsyncThunk(
  'user/logout',
  async (_undefined, { getState }): Promise<string> => {
    const {
      user: { userInfo }
    } = getState() as RootState

    const data = {
      id: userInfo?.userDetail?.usersId
    }
    const response = await api.post(apiEndpoints.logout, data)
    return response?.data?.data
  }
)

export const handleResetPassword = createAsyncThunk(
  'user/resetPassword',
  async (newPassword: string, { getState, dispatch }): Promise<string> => {
    const {
      user: { userInfo, password }
    } = getState() as RootState

    const data = {
      id: userInfo?.userDetail?.usersId,
      password,
      newPassword
    }
    const response = await api.post(apiEndpoints.resetPassword, data)
    const { userName, loginDevice } = response?.data?.data
    if (userName && loginDevice) {
      dispatch(updateUserName(userName))
      dispatch(updatePassword(newPassword))
      dispatch(
        handleAuthenticate({
          loginDevice
        })
      )
    }
    return response?.data?.data
  }
)

export const getUploadedFiles = createAsyncThunk(
  'user/getUploadedFiles',
  async (currentPage: string): Promise<UploadFileResponse> => {
    const data = {
      pageNo: currentPage,
      pageSize: '20',
      sortBy: 'createdAt',
      ascDesc: 'Desc',
      searchCriteria: { entityType: 'student' }
    }

    const response = await api.post(apiEndpoints.uploadFile, data)
    return {
      fileList: response?.data?.content,
      pageSize: response?.data?.totalPages,
      currentPage: response?.data?.number
    }
  }
)

export const uploadBulkEntry = createAsyncThunk(
  'user/bulkEntry',
  async (
    { instituteId, batchId, branchId, file }: SaveBulkEntryPayload,
    { getState, dispatch }
  ): Promise<File> => {
    const {
      user: { userInfo }
    } = getState() as RootState

    const formData = new FormData()
    formData.append('loggedInUserId', userInfo?.userDetail?.usersId || '')
    formData.append('file', file)
    formData.append('entity', 'student')
    formData.append('coachingCenterId', instituteId)
    formData.append('branchId', branchId)
    formData.append('courseId', branchId)
    formData.append('batchId', batchId || '')

    const response = await api.post(apiEndpoints.bulkEntry, formData)
    if (response) {
      dispatch(getUploadedFiles('1'))
    }
    return response?.data?.data
  }
)

export const downloadStudentActivity = createAsyncThunk(
  'user/studentActivity',
  async (_undefined, { getState }): Promise<string> => {
    const {
      user: {
        studentActivity: { startDate, toDate, instituteId, branchId, batchId }
      }
    } = getState() as RootState

    const response = await api.get(
      `${apiEndpoints.downloadStudentActivity
      }?coachingCentreId=${instituteId}&branchIds=${branchId}&batchIds=${batchId}&startDate=${format(
        startDate,
        DATE_FORMAT_YYYYMMDD
      )}&endDate=${format(toDate, DATE_FORMAT_YYYYMMDD)}`
    )
    const downloadFile = response?.data?.data
    if (downloadFile) {
      window.location.href = downloadFile
    }
    return downloadFile || ''
  }
)

export const clearLogin = createAsyncThunk(
  ' login/createLogin',
  async (): Promise<any> => {
    const response = await api.get(apiEndpoints.clearLoginend)
    return response.data
  }
)